<!--
 * @Description: 
 * @Author: yingbin
 * @Date: 2019-07-05 13:52:43
 * @LastEditTime: 2019-08-14 13:36:24
 * @LastEditors: yingbin
 -->
<template>
  <div class="address">
    <div class="search">
      <el-input
        placeholder="可对寄件人姓名，手机号进行搜索"
        v-model.trim="keyword"
        clearable
      >
        <template slot="append">
          <el-button
            @click="search"
            slot="append"
            :loading="isSearch"
            icon="el-icon-search"
            >搜索</el-button
          >
        </template>
      </el-input>
      <div class="itemView" style="font-size: 12px;cursor: pointer;" @click="goerrorTip()" v-if="$store.state.teamModel=='2'">
         <span style="line-height: 40px; color: red; padding-left: 10px;">*</span>
         <span >
        团队共享地址仅允许团员本人修改和删除，其他团员仅可使用或复制</span>
        
       <i class="el-icon-question " style="color: #409EFF;"></i></div>

    </div>
    <div class="table">
      <el-table
        ref="singleTable"
        :data="tableData"
        height="400px"
        max-height="400px"
        highlight-current-row
        empty-text=" "
        style="width: 100%"
        size="mini"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        @row-click="selectRadio"
      >
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column
          align="left"
          property="name"
          label="姓名"
          width="200"
        >
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
        </el-table-column>
        <el-table-column
          align="center"
          property="phone"
          label="手机号"
          width="200"
        ></el-table-column>
        <el-table-column align="left" label="地址" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag v-if='scope.row.account_id != account_id' size="mini">共享地址</el-tag>
            <el-tag v-if='scope.row.account_id == account_id&&scope.row.address_type == 2' size="mini">默认</el-tag>
            {{ scope.row.province_name }} {{ scope.row.city_name }}
            {{ scope.row.district_name }} {{ scope.row.address }}</template
          >
        </el-table-column>
        <div slot="empty" class="noBody" v-if="haveData">
          <img src="@/assets/images/nodata.png" alt />
        </div>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="10"
        layout="prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      <div slot="append" class="sure" type="primary">确定</div>
    </div>
    <div class="btn_list">
      <el-row>
        <el-button @click="closeChoice" size="mini">取消</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import home from "@/api/home";
import util from "@/util/util";
export default {
  name: "",
  data() {
    return {
      loading: true,
      keyword: "", //搜索关键字
      isSearch: false, // 搜索加载
      total: 0,
      tableData: [],
      currentPage: 1,
      haveData: false,
      account_id: util.getCookie("account_id")
    };
  },
  created() {
  },
  mounted: function() {
    //数据挂载
     this.getTableList(this.currentPage);
  },
  methods: {
    goerrorTip(){
      const Obstruct = util.getJsonValues(this.$store.state.commondict,'printObstruct')
      if(Obstruct){
        const Item = JSON.parse(Obstruct).teamAddress
        window.open(Item)
      }
    },
    /**获取寄件人类表 */
    getTableList(currentPage) {
      let self = this;
      self.loading = true;
      home.getAddressList(self, 1, currentPage).then(res => {
        if (res.success) {
          self.loading = false;
          self.total = res.data.total;
          self.tableData = res.data.list;
          if (res.data.list.length > 0) {
            this.haveData = false;
          } else {
            this.haveData = true;
          }
        } else {
          self.total = 0;
          self.loading = false;
        }
      });
    },
    /**搜索寄件人 */
    search() {
      let self = this;
      self.isSearch = true;
      self.loading = true;
      self.currentPage = 1;
      home.getAddressList(this,1,self.currentPage).then(res => {
        self.isSearch = false;
        if (res.success) {
          self.loading = false;
          self.total = res.data.total;
          self.tableData = res.data.list;
          if (res.data.length > 0) {
            this.haveData = false;
          } else {
            this.haveData = true;
          }
        } else {
          self.loading = false;
        }
      });
    },

    handleCurrentChange(val) {
      this.getTableList(val);
      console.log(`当前页: ${val}`);
    },
    /**单个选中寄件人信息 */
    selectRadio(row) {
      let parent = this.$parent.$parent;
      if(this.$route.name == 'sheet'){
        parent.addressId = row.id
        const isdefault = row.address_type == 2 ? '(默认)' : ''
        parent.sendAddress = isdefault +
        row.name+' '+
        row.phone+' '+
        row.province_name + 
        row.city_name+
        row.district_name+
        row.address
      }else{
        let clickItme = {
          name: row.name,
          phone: row.phone,
          province: row.province_name,
          province_code: row.province_code,
          city: row.city_name,
          city_code: row.city_code,
          area: row.district_name,
          area_code: row.district_code,
          address: row.address,
          pca: [row.province_code, row.city_code, row.district_code],
          address_id:row.id
        };
        parent.ruleForm.send = clickItme;
        parent.sendHolder = row.province_name + '/' + row.city_name + '/'+ row.district_name;
        this.$route.fullPath == '/home?id=2' ? parent.idChecked() : parent.setPreSave();        
      }

      parent.dialog = false;
      // parent.$refs.ruleForm.clearValidate();
    },
    /**关闭选择 */
    closeChoice() {
      this.$refs.singleTable.clearSelection();
      this.$parent.$parent.dialog = false;
    }
  }
};
</script>
<style lang="stylus" scoped>
.address {
  .search {
    width: 880px;
    margin: 0 auto;
  }

  .table {
    padding: 0 20px;
    margin-top: 20px;

    .newpend {
      // cursor: pointer;
      color: #2288F8;
    }

    /deep/ .el-table tr {
      cursor: pointer;
    }
  }

  .page {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;

    .sure {
      display: inline-block;
      width: 48px;
      height: 28px;
      margin: 0 5px;
      font-size: 12px;
      text-align: center;
      line-height: 28px;
      border-radius: 4px;
      border: 1px solid rgba(220, 220, 220, 1);
      cursor: pointer;
    }

    .sure:hover {
      background: #2288f8;
      border: 1px solid #2288f8;
      color: #fff;
    }
  }

  .btn_list {
    margin-top: 20px;

    .el-row {
      text-align: center;

      button {
        margin: 0 20px;
        padding: 12px 50px;
      }
    }
  }

  .noBody {
    min-height: 40vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 16px;

    img {
      width: 255px;
      height: 255px;
    }
  }
}
</style>
